<template>
  <div>
    <VSlideGroup
      ref="slideGroup"
      v-model="sliderModel"
      :show-arrows="showArrows"
      mandatory
      class="photoSlider"
    >
      <VSlideItem
        v-for="photo in photos"
        :key="photo.id"
        v-slot:default="{ toggle }"
        class="ma-2"
      >
        <AppPhotoGalleryItem
          :photo="photo"
          @load="updateSlider"
          @click.native="handleClick(toggle)"
        />
      </VSlideItem>
    </VSlideGroup>

    <VDialog
      v-model="photoDialog"
      width="80%"
    >
      <VCard
        v-if="photoDialog"
        class="grey lighten-3"
      >
        <VCarousel
          v-model="carouselModel"
          hide-delimiters
          :height="height"
        >
          <VCarouselItem
            v-for="photo in photos"
            :key="photo.id"
          >
            <VImg
              :src="photo.photo.url"
              contain
              height="100%"
            />
          </VCarouselItem>
        </VCarousel>
      </VCard>
      <div v-else />
    </VDialog>
  </div>
</template>

<script>
import AppPhotoGalleryItem from './AppPhotoGalleryItem.vue';

export default {
  name: 'AppPhotoGallery',
  components: { AppPhotoGalleryItem },
  props: {
    photos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sliderModel: 0,
      photoDialog: false,
      carouselModel: 0,
    };
  },
  computed: {
    height() {
      return window.innerHeight * 0.8;
    },
    showArrows() {
      return !this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    handleClick(toogle) {
      toogle();
      this.carouselModel = this.sliderModel;
      this.photoDialog = true;
    },
    updateSlider() {
      this.$refs.slideGroup.setWidths();
    },
  },
};
</script>
<style lang="scss" scoped>
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .photoSlider {
    &:not(.v-slide-group--has-affixes) {
      &::v-deep {
        .v-slide-group__prev--disabled {
          display: flex;
          opacity: 0;
          pointer-events: none;
        }
      }
    }
  }
}
</style>
